export enum PaymentTermsCategory {
  Vendor = "Vendor",
  Customer="Customer"
}
